module.exports = __webpack_public_path__ + "img/clients-4.6f05e27a.png";